import React from "react";
import { NavLink } from "react-router-dom";
import "../App.css";

export const Header = () => {
  return (
    <div className="lis-header">
      <div className="links">
        <NavLink to="/" className="link">
          Home
        </NavLink>
        <NavLink to="/project" className="link">
          Projects
        </NavLink>
        {/* <NavLink to="/about" className="link">
          About
        </NavLink> */}
        <NavLink to="/cv" className="link">
          CV
        </NavLink>
        <NavLink to="/contact" className="link">
          Contact
        </NavLink>
        
      </div>
    </div>
  );
};
